module.exports = __webpack_public_path__ + "img/icon (18).c8d0a4fe.png";